import { useState } from 'react';
import { toast } from 'sonner';
import { Warning, X } from '@phosphor-icons/react';
import api from '../lib/api';

// Generic confirmation card for Crunchy's destructive actions
// (delete_contacts, merge_contacts, delete_template). Nothing executes
// until the user hits Confirm here.
export default function ConfirmActionCard({ open, preview, onClose }) {
  const [applying, setApplying] = useState(false);
  if (!open || !preview) return null;

  const apply = async () => {
    setApplying(true);
    try {
      const { data } = await api.post('/ai/confirm-action', {
        action_type: preview.action_type,
        payload: preview.payload || {},
      });
      toast.success(data.message || 'Done');
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Action failed');
    } finally {
      setApplying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9998] bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="confirm-action-overlay">
      <div className="bg-white border border-[#B0B0B0] shadow-2xl w-full max-w-[440px] rounded-sm" onClick={(e) => e.stopPropagation()} data-testid="confirm-action-card">
        <div className="px-3 py-2 bg-[#B91C1C] text-white text-[12px] font-bold flex items-center justify-between">
          <span className="flex items-center gap-1.5"><Warning size={14} weight="fill" /> Crunchy needs your OK</span>
          <button onClick={onClose} className="p-0.5 hover:bg-white/20 rounded" data-testid="confirm-action-close" aria-label="Close">
            <X size={13} weight="bold" />
          </button>
        </div>
        <div className="p-4 space-y-2">
          <p className="text-[14px] font-bold text-[#111] m-0" data-testid="confirm-action-title">{preview.title}</p>
          {(preview.summary || []).map((line, i) => (
            <p key={i} className="text-[12px] text-[#444] m-0" data-testid={`confirm-action-line-${i}`}>{line}</p>
          ))}
        </div>
        <div className="px-4 py-2.5 border-t border-[#EEE] flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1.5 text-[11px] border border-[#999] bg-white hover:bg-[#F5F5F5] rounded-sm" data-testid="confirm-action-cancel">Cancel</button>
          <button
            onClick={apply}
            disabled={applying}
            className="px-3 py-1.5 text-[11px] font-bold bg-[#B91C1C] hover:bg-[#991B1B] text-white disabled:opacity-60 rounded-sm"
            data-testid="confirm-action-apply"
          >
            {applying ? 'Working…' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
